module.exports = __webpack_public_path__ + "img/nor.e9a36852.png";